module.exports = __webpack_public_path__ + "static/media/founder_ongttirenetan.913fb762.png";